export default __webpack_public_path__ + "static/img2-bcec103907559117a4d9e4a821c2dc67.jpg";